export default __webpack_public_path__ + "static/media/The Outlanders.31add542.jpg";